import { render, staticRenderFns } from "./VectorSettingPanel.vue?vue&type=template&id=6885b871&scoped=true"
import script from "./VectorSettingPanel.vue?vue&type=script&lang=js"
export * from "./VectorSettingPanel.vue?vue&type=script&lang=js"
import style0 from "./VectorSettingPanel.vue?vue&type=style&index=0&id=6885b871&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885b871",
  null
  
)

export default component.exports